<!--
    描述：顶部多选筛选栏
    时间：2020-05-15
    Created by ws
-->
<template>
	<div class="filter-main">
		<div class="filter-item"
			 v-for="(item, index) in filterColumns"
			 :key="'row' + index"
			 :class="{ customHeight: item.custom }">
			<div class="left-text">{{ item.sname }}</div>
			<ul class="right-list">
				<li class="check-all"
					:class="{'active-item': item.checkAll}"
					@click="hanldeClickAll(item)"><span>全部</span></li>
				<li class="check-item text-overflow"
					v-for="(m, n) in item.list"
					:key="'list' + n"
					:class="{'active-item': m.checked}"
					@click="handleClick(item, m)"><span>{{ m.label }}</span></li>
			</ul>
		</div>
		<template v-if="forSearch">
			<el-row style="width: 80%">
				<el-col class="flex">
					<span class="tag">项目标签：</span>
					<el-select v-model="tags"
							   placeholder="请选择标签"
							   popper-class="tag-box"
							   multiple
							   filterable
							   clearable
							   size="small"
							   class="w100"
							   ref="selectOption"
							   @change="tagChange"
							   @clear="tagChange"
							   @focus="setOptionWidth">
						<el-option v-for="(item, index) in tagList"
								   :key="'tagList' + index"
								   :label="item.sname"
								   :value="item.id"></el-option>
					</el-select>
				</el-col>
			</el-row>
		</template>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import * as API from '@/api/modules/home'
export default {
	props: {
		// 行筛选数组
		columns: {
			type: Array,
			default: () => {
				return []
			},
		},
		forSearch: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			filterColumns: [],
			status: true,
			timer: null,
			tags: [],
			tagList: [],
		}
	},
	created() {
		this.setDefaultList()
		// 获取所有标签
		this.getAllTags()
	},
	methods: {
		// 获取所有标签
		getAllTags() {
			API.selectTagListForBox({
				applys: '1056001',
			}).then((res) => {
				this.tagList = res.data
			})
		},

		// 点击高亮
		handleClick(row, item) {
			this.status = false
			item.checked = !item.checked

			// 全选处理
			let list = row.list.filter((x) => x.checked)
			row.checkAll = list.length === 0 ? true : false

			this.doDelay()
		},

		// 点击全部
		hanldeClickAll(row) {
			row.checkAll = !row.checkAll

			if (row.checkAll) {
				row.list.map((x) => (x.checked = false))
			}

			// 延迟防抖事件
			this.doDelay()
		},

		// 标签选择
		tagChange() {
			this.doDelay()
		},

		// 设置下拉框弹框宽度
		setOptionWidth(e) {
			this.$nextTick(() => {
				let ele = document.querySelectorAll('.tag-box .el-scrollbar')
				if (e.path) {
					ele[0].style.width = e.path[1].offsetWidth + 'px'
				}
			})
		},

		// 延迟函数
		doDelay() {
			// 如果此时定时器在， 清除
			if (this.timer) {
				clearTimeout(this.timer)
			}

			// 没继续点击后 做操作处理
			this.timer = setTimeout(() => {
				this.status = true
				if (this.status) {
					this.backList()
				}
			}, 1000)
		},

		// 返回参数
		backList() {
			let arr = []
			this.filterColumns.forEach((x) => {
				if (x.checkAll) {
					let obj = {
						sname: x.sname,
						list: [],
					}
					arr.push(obj)
				} else {
					let _list = x.list.filter((y) => y.checked)
					let obj = {
						sname: x.sname,
						list: [..._list],
					}
					arr.push(obj)
				}
			})

			if (this.forSearch) {
				let obj = {
					sname: '项目标签',
					list: this.tags,
				}
				arr.push(obj)
			}
			this.$emit('doFilter', arr)
		},

		// 设置默认数组
		setDefaultList() {
			// 年份数组
			let year_dict = []
			let nowDate = new Date();
			let fullYear = nowDate.getFullYear();
			let yearNum = fullYear - 2017;
			for (var i = 0; i <= yearNum; i++) {
				year_dict.push({
					label: (fullYear - i) + '年',
					value: fullYear - i,
					checked: false,
				})
			}

			// 项目来源数组
			let source_dict = [
				{
					label: '手动新建',
					value: '1013001',
					checked: false,
				},
				{
					label: '历史项目',
					value: '1013002',
					checked: false,
				},
				{
					label: '批量导入',
					value: '003',
					checked: false,
				},
				{
					label: '外部接口',
					value: '004',
					checked: false,
				},
			]
			// 地区数组
			let area_dict = [
				{
					label: '合肥市', value: '1012001001', checked: false,
				},
				{
					label: '芜湖市', value: '1012001002', checked: false,
				},
				{
					label: '蚌埠市', value: '1012001003', checked: false,
				},
				{
					label: '马鞍山市', value: '1012001004', checked: false,
				},
				{
					label: '滁州市', value: '1012001005', checked: false,
				},
				{
					label: '淮南市', value: '1012001006', checked: false,
				},
				{
					label: '淮北市', value: '1012001007', checked: false,
				},
				{
					label: '六安市', value: '1012001008', checked: false,
				},
				{
					label: '铜陵市', value: '1012001009', checked: false,
				},
				{
					label: '宣城市', value: '1012001010', checked: false,
				},
				{
					label: '黄山市', value: '1012001011', checked: false,
				},
				{
					label: '池州市', value: '1012001012', checked: false,
				},
				{
					label: '阜阳市', value: '1012001013', checked: false,
				},
				{
					label: '亳州市', value: '1012001014', checked: false,
				},
				{
					label: '宿州市', value: '1012001015', checked: false,
				},
				{
					label: '安庆市', value: '1012001016', checked: false,
				}
			]

			// 项目类型
			let type_dict = this.gclx.map(i => {
				return { label: i.sname, value: i.value, checked: false }
			})


			let default_list = [
				{
					sname: '开工年份：',
					checkAll: true,
					list: year_dict,
				},
				{
					sname: '项目来源：',
					checkAll: true,
					list: source_dict,
				},
				{
					sname: '地区数组：',
					checkAll: true,
					list: area_dict,
				},
				{
					sname: '项目类型：',
					checkAll: true,
					list: type_dict,
				},
				// {
				// 	sname: '单项工程类型：',
				// 	checkAll: true,
				// 	list: unit_type_dict
				// }
			]
			this.filterColumns =
				this.columns.length === 0 ? default_list : this.columns
		},
	},
	computed: {
		...mapState('dict', {
			gclx: (state) => state.gclx
		}),
	},
}
</script>

<style scoped lang="less">
.filter-main {
	@activeColor: #409eff;

	padding: 5px 0;
	// min-width: max-content;
	padding-bottom: 10px;
	width: 100%;

	.filter-item {
		display: flex;
		// height: 28px;
		line-height: 28px;
		font-size: 14px;
	}

	.left-text {
		width: 130px;
		padding: 0 10px;
		text-align: right;
	}

	.right-list {
		flex: 1;

		.check-all {
			display: inline-block;
			cursor: pointer;
			margin-right: 15px;
			vertical-align: top;
		}

		.check-item {
			cursor: pointer;
			margin: 0 10px;
			width: 80px;
			display: inline-block;
			padding: 0 5px;
		}

		.active-item {
			span {
				color: @activeColor;
				font-weight: 700;
			}
		}
	}

	.customHeight {
		margin-top: 5px;
		height: 32px !important;

		/deep/ .el-select__input {
			height: 32px !important;
		}
	}

	.tag {
		display: inline-block;
		min-width: 120px;
		line-height: 32px;
		text-align: right;
		font-size: 14px !important;
	}
}
</style>

<style lang="less">
.tag-box {
	width: 100%;
	.el-scrollbar {
		.el-select-dropdown__wrap {
			.el-select-dropdown__list {
				display: flex !important;
				flex-wrap: wrap;
				padding: 6px;

				.el-select-dropdown__item {
					padding: 5px 10px;
					height: 25px;
					line-height: 15px;
					border: 1px solid #c9e4ff;
					color: #409eff;
					border-radius: 4px;
					margin-right: 5px;
					margin-bottom: 3px;
				}

				.el-select-dropdown__item.selected {
					border: 1px solid #409eff;
				}

				.el-select-dropdown__item.selected::after {
					display: none !important;
				}
			}
		}
	}
}
</style>